var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25008 3.6665H4.58341C4.07715 3.6665 3.66675 4.07691 3.66675 4.58317V8.24984C3.66675 8.7561 4.07715 9.1665 4.58341 9.1665H8.25008C8.75634 9.1665 9.16675 8.7561 9.16675 8.24984V4.58317C9.16675 4.07691 8.75634 3.6665 8.25008 3.6665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 3.6665H13.7501C13.2438 3.6665 12.8334 4.07691 12.8334 4.58317V8.24984C12.8334 8.7561 13.2438 9.1665 13.7501 9.1665H17.4167C17.923 9.1665 18.3334 8.7561 18.3334 8.24984V4.58317C18.3334 4.07691 17.923 3.6665 17.4167 3.6665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25008 12.8332H4.58341C4.07715 12.8332 3.66675 13.2436 3.66675 13.7498V17.4165C3.66675 17.9228 4.07715 18.3332 4.58341 18.3332H8.25008C8.75634 18.3332 9.16675 17.9228 9.16675 17.4165V13.7498C9.16675 13.2436 8.75634 12.8332 8.25008 12.8332Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 12.8332H13.7501C13.2438 12.8332 12.8334 13.2436 12.8334 13.7498V17.4165C12.8334 17.9228 13.2438 18.3332 13.7501 18.3332H17.4167C17.923 18.3332 18.3334 17.9228 18.3334 17.4165V13.7498C18.3334 13.2436 17.923 12.8332 17.4167 12.8332Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25008 3.6665H4.58341C4.07715 3.6665 3.66675 4.07691 3.66675 4.58317V8.24984C3.66675 8.7561 4.07715 9.1665 4.58341 9.1665H8.25008C8.75634 9.1665 9.16675 8.7561 9.16675 8.24984V4.58317C9.16675 4.07691 8.75634 3.6665 8.25008 3.6665Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 3.6665H13.7501C13.2438 3.6665 12.8334 4.07691 12.8334 4.58317V8.24984C12.8334 8.7561 13.2438 9.1665 13.7501 9.1665H17.4167C17.923 9.1665 18.3334 8.7561 18.3334 8.24984V4.58317C18.3334 4.07691 17.923 3.6665 17.4167 3.6665Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25008 12.8332H4.58341C4.07715 12.8332 3.66675 13.2436 3.66675 13.7498V17.4165C3.66675 17.9228 4.07715 18.3332 4.58341 18.3332H8.25008C8.75634 18.3332 9.16675 17.9228 9.16675 17.4165V13.7498C9.16675 13.2436 8.75634 12.8332 8.25008 12.8332Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 12.8332H13.7501C13.2438 12.8332 12.8334 13.2436 12.8334 13.7498V17.4165C12.8334 17.9228 13.2438 18.3332 13.7501 18.3332H17.4167C17.923 18.3332 18.3334 17.9228 18.3334 17.4165V13.7498C18.3334 13.2436 17.923 12.8332 17.4167 12.8332Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.2e5b2c778e1bf9952c12a42f89556a2d.svg";
export { ForwardRef as ReactComponent };